import useReactHookForm from "hooks/useReactHookForm";
import {
  checkIfPeriodic,
  createExamScheduleSec1,
  createExamScheduleSec2,
  createExamSchSec1MandatoryFields,
  createExamSchSec1ValidationSchema,
  createExamSchSec2MandatoryFields,
  createExamSchSec2ValidationSchema,
  filterSubjects,
  formatToISTISOString,
  isFormIncomplete,
} from "../helper";
import { Alert, Box, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import { TypographyHeading } from "shared/molecules/typography-layout";
import ContentRight from "shared/molecules/content-right";
import LoadingButton from "@mui/lab/LoadingButton";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useEffect, useState } from "react";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import {
  getBatchFromClassIdReturn,
  getCollegeFromStateId,
} from "utils/metadata-split/depedentApiFetch";
import { areArraysEqual, setReactFormValues } from "pages/configue/constants";
import { useLazyQuery, useMutation } from "@apollo/client";
import { CREATE_EXAM_SCHEDULE } from "utils/graphql/services/exam-schedule/mutations";
import myClassroomClient from "utils/graphql/myclassroom";
import { isEmpty } from "utils/helpers";
import { useHistory } from "react-router-dom";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import { GET_COURSES_LIST, GET_SUBJECTS_FOR_DROPDOWN } from "utils/graphql/services/exam-schedule/queries";

export const CreateExamSchedule = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    createExamSchSec1MandatoryFields,
    createExamSchSec1ValidationSchema,
    ""
  );
  const {
    control: controlSec2,
    errors: errorsSec2,
    getValues: getValuesSec2,
    watch: watchSec2,
    setValue: setValueSec2,
  } = useReactHookForm(
    createExamSchSec2MandatoryFields,
    createExamSchSec2ValidationSchema,
    ""
  );

  const dispatch = useAppDispatch();
  const history = useHistory();
  const [triggerSetValue, setTriggerSetValue] = useState(false);
  const [createLoad, setCreateLoad] = useState(false);
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const [createExamSchdule, { loading, error, data }] = useMutation(
    CREATE_EXAM_SCHEDULE,
    {
      client: myClassroomClient,
    }
  );

    const [
      getCourseProgramTypes,
      { loading: loadingCP, error: errorCP, data: dataCP },
    ] = useLazyQuery(GET_COURSES_LIST, {
      client: myClassroomClient,
      fetchPolicy: "no-cache",
    });

  const [
    getSubjectsDropdown,
    { loading: loadingSub, error: errorSub, data: dataSub },
  ] = useLazyQuery(GET_SUBJECTS_FOR_DROPDOWN, {
    client: myClassroomClient,
        fetchPolicy: "no-cache",
  });

  function getValuesByIds(ids, objects, key = "name", key_id) {
    // Create a lookup (dictionary) for faster access
    return ids.map((id) => {
      const found = objects.find((obj) => obj[key_id] === id);
      return found ? found[key] : null;
    });
  }

  const updateMetaDataMulti = (listData, metaKey, listData2, metaKey2,listData3, metaKey3) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    metadataList[metaKey3] = listData3;
    dispatch(metadataSuccess(metadataList));

    if (metaKey == "course_program_list" && listData?.length == 0) {
      setValue("course_ids", []);
    }
    if (metaKey2 == "batch_list" && listData2?.length == 0) {
      setValueSec2("batch_ids", []);
    }
    if (metaKey3 == "subject_course_program_list" && listData3?.length == 0) {
      setValue("subject_ids", []);
    }
  };

    const modifyCourseNames = (data) => {
    return data.map((item) => ({
      ...item,
      name: `${item.type}-${item.name}`,
    }));
  };

  const handleCreateExamSchdule = async () => {
    setCreateLoad(true);
    try {
      const payload = {
        scheduled_exam_type_id: watch()?.scheduled_exam_type_id,
        scheduled_exam_type_name: getValuesByIds(
          [watch()?.scheduled_exam_type_id],
          metaData?.exam_type_gq,
          "name",
          "id"
        )?.[0],
        scheduled_exam_name: watch()?.scheduled_exam_name,
        scheduled_date:formatToISTISOString(watch()?.start_date),
        scheduled_start_time: watch()?.minTime,
        scheduled_end_time: watch()?.maxTime,
        subjects:filterSubjects(watch()?.subject_ids,metaData?.subject_course_program_list),
        course_ids: watch()?.course_ids,
        course_names: getValuesByIds(
          watch()?.course_ids,
          metaData?.course_program_list,
          "name",
          "id"
        ),

        academic_year_ids: watchSec2()?.academic_year_ids,
        academic_year_names: getValuesByIds(
          watchSec2()?.academic_year_ids,
          metaData?.academic_year_list,
          "year_name",
          "year_id"
        ),
        college_ids: watchSec2()?.college_ids,
        college_names: getValuesByIds(
          watchSec2()?.college_ids,
          metaData?.college_list,
          "college_name",
          "college_id"
        ),
        board_ids: watchSec2()?.board_ids,
        board_names: getValuesByIds(
          watchSec2()?.board_ids,
          metaData?.board_list,
          "board_name",
          "board_id"
        ),
        class_ids: [`${watch()?.class_id}`],
        class_names: getValuesByIds(
          [`${watch()?.class_id}`],
          metaData?.class_list_schdule,
          "name",
          "id"
        ),
        batch_ids: watchSec2()?.batch_ids,
        batch_names: getValuesByIds(
          watchSec2()?.batch_ids,
          metaData?.batch_list,
          "batch_name",
          "batch_id"
        ),
        state_ids: watchSec2()?.state_ids,
        state_names: getValuesByIds(
          watchSec2()?.state_ids,
          metaData?.state_list,
          "state_name",
          "state_id"
        ),
        is_archived: false,
        status: "ACTIVE",
        sort_order: 1,
      };
      const response: any = await createExamSchdule({
        variables: {
          input: payload,
        },
      });
      if (!isEmpty(response?.data?.createExamSchedule)) {
        dispatch(snackbarRequest({ message: "Created Exam successfully" }));
        setCreateLoad(false);
        history.replace(`/exam_schedule/list`);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.errorReason}`,
            type: "error",
          })
        );
        setCreateLoad(false);
      }
    } catch (err: any) {
      dispatch(snackbarRequest({ message: `${err?.message}`, type: "error" }));
      setCreateLoad(false);
    }
  };

  const updateMetaData = async (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    await dispatch(metadataSuccess(metadataList));
    if (metaKey == "batch_list" && listData?.length == 0) {
      setValueSec2("batch_ids", []);
    }
    if (metaKey == "college_list" && listData?.length == 0) {
      setValueSec2("college_ids", []);
    }
    if (metaKey == "subject_course_program_list" && listData?.length == 0) {
      setValue("subject_ids", []);
    }
  };


  useEffect(() => {
    (async () => {
      await getCollegeFromStateId(watchSec2()?.state_ids, updateMetaData);
    })();
  }, [watchSec2()?.state_ids]);

  useEffect(() => {
  const classId = watch("class_id");
  if (isEmpty(classId)){
      updateMetaDataMulti([],"course_program_list",[],"batch_list",[],"subject_course_program_list")
    return;
  } 

  const fetchData = async () => {
    try {

      const [
        courseProgramRes,
        batchRes
      ] = await Promise.all([
        getCourseProgramTypes({
          variables: { classId },
        }),
        getBatchFromClassIdReturn(classId,"")
      ]);

      const courseList =
        courseProgramRes?.data?.getCoursesList || [];

      const [batchData, batchKey] = batchRes;
     updateMetaDataMulti(modifyCourseNames(courseList),"course_program_list",batchData,batchKey,[],"subject_course_program_list")
    } catch (error) {
        updateMetaDataMulti([],"course_program_list",[],"batch_list",[],"subject_course_program_list")
    }
  };

  fetchData();
}, [watch("class_id")]);

useEffect(() => {
  const classId = watch()?.class_id;
  const courses = watch()?.course_ids;

  if (isEmpty(classId) || isEmpty(courses)) {
    updateMetaData([], "subject_course_program_list")
    return;
  }

  const fetchSubjects = async () => {
    try {
      const res = await getSubjectsDropdown({
        variables: {
          courseIds: watch()?.course_ids,
          classId: watch()?.class_id,
        },
      });

      const list = res?.data?.getSubjectsForDropdown || [];

      updateMetaData(isEmpty(list) ? [] : list, "subject_course_program_list");
    } catch (error) {
      updateMetaData([], "subject_course_program_list");
    }
  };

  fetchSubjects();
},[watch("course_ids")]);


  useEffect(() => {
    if (metaData?.batch_list?.length > 0 && !isLoad) {
      let matchedVales = setReactFormValues(
        metaData,
        "batch_list",
        watchSec2()?.batch_ids,
        "batch_id"
      );
      let isEqual = areArraysEqual(watchSec2()?.batch_ids, matchedVales);
      if (!isEqual) {
        setValueSec2("batch_ids", matchedVales);
      }
    }
  }, [metaData?.batch_list, triggerSetValue]);

  useEffect(() => {
    if (metaData?.college_list?.length > 0 && !isLoad) {
      let matchedVales = setReactFormValues(
        metaData,
        "college_list",
        watchSec2()?.college_ids,
        "college_id"
      );
      let isEqual = areArraysEqual(watchSec2()?.college_ids, matchedVales);
      if (!isEqual) {
        setValueSec2("college_ids", matchedVales);
      }
    }
  }, [metaData?.college_list]);

  useEffect(() => {
    if (metaData?.subject_course_program_list?.length > 0 && !isLoad) {
      let matchedVales = setReactFormValues(
        metaData,
        "subject_course_program_list",
        watch()?.subject_ids,
        "id"
      );
      let isEqual = areArraysEqual(watch()?.subject_ids, matchedVales);
      if (!isEqual) {
        setValue("subject_ids", matchedVales);
      }
    }
  }, [metaData?.subject_course_program_list]);

    const isPeriodicMultiple = checkIfPeriodic( watch("scheduled_exam_type_id"),
        metaData?.exam_type_gq) && watch("subject_ids").length > 1;

  return (
    <>
      <TypographyHeading>Schedule</TypographyHeading>
      {isPeriodicMultiple && (
          <Box sx={{ paddingLeft:"60%",marginBottom:"20px",marginTop:"10px" }}>
            <Alert severity="error" variant="filled">
              Please select a single subject when the exam type is{" "}
              <b>Periodic</b>.
            </Alert>
          </Box>
        )}
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={createExamScheduleSec1()}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        </Grid>
      </Paper>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2, marginTop: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={createExamScheduleSec2()}
            control={controlSec2}
            errors={errorsSec2}
            getValues={getValuesSec2}
            setValue={setValueSec2}
            watch={watchSec2}
          />
        </Grid>
      </Paper>

      <ContentRight sx={{ mt: -1 }}>
        <LoadingButton
          variant="contained"
          loadingPosition="start"
          loading={createLoad}
          sx={{
            width: "180px",
            height: "40px",
            marginTop: "15px",
            marginRight: "10px",
            padding: "7px 23.5px 7px 23.5px",
            cursor: "pointer",
            textAlign: "center",
          }}
          onClick={handleCreateExamSchdule}
          disabled={isFormIncomplete(watch(), watchSec2()) || isPeriodicMultiple }
        >
          Save
        </LoadingButton>
      </ContentRight>
    </>
  );
};
